import { useIndexStore } from '~/store';

export default defineNuxtPlugin(() => {
  const { $logger, $sendCustomYandexMetrika } = useNuxtApp();
  const indexStore = useIndexStore();
  const log = $logger.withScope('🚩yandexMetrika');

  watch(
    () => indexStore.userIntegerId,
    (userId) => {
      if (!userId) return;
      try {
        log('userId', userId);
        $sendCustomYandexMetrika({ user_id: userId });
      } catch (err) {
        console.error('send user id', err);
      }
    },
  );
});
